/* Side-shield accessory PDP only. Gated by Fits select — never runs on Z87. */
(function () {
  const root =
    document.querySelector('.sep-design-pdp.is-side-shield-pdp') ||
    (document.querySelector('[data-ss-fits]') &&
      document.querySelector('[data-ss-fits]').closest('.sep-design-pdp'))
  if (!root) return
  root.classList.add('is-side-shield-pdp')

  const SW = {
    Black: '#1b1b1f',
    Clear: '#e7edf2',
    Smoke: '#6b6b70',
    'Stormy Gray': '#878e97'
  }
  const DESC = {
    Black: 'Matches every black Z87+ frame',
    Clear: 'Transparent - full side vision, zero tint',
    Smoke: 'Translucent - keeps some peripheral light',
    'Stormy Gray': 'Warmer gray, matches the Stormy Gray finish'
  }

  let catalog = []
  const catalogEl = root.querySelector('[data-ss-catalog]')
  if (catalogEl) {
    try {
      catalog = JSON.parse(catalogEl.textContent || '[]') || []
    } catch (e) {
      catalog = []
    }
  }

  const qty = {}
  // Back-in-stock state per variant id: 'open' (email field showing), 'sending', 'done'.
  const notify = {}
  const notifyErr = {}
  const mailDraft = {}
  let lastHandle = ''
  // "I have a regular (non-Z87+) pair" in the Fits select. Blocks colors + ATC.
  const GATE_VALUE = 'none'
  let gated = false

  function catalogItem(handle) {
    return catalog.find((p) => p && p.handle === handle) || null
  }

  function currentHandle() {
    const sel = root.querySelector('[data-ss-fits]')
    if (sel && sel.value && sel.value !== GATE_VALUE) return sel.value
    if (lastHandle) return lastHandle
    return (
      (window.pdp && (window.pdp.currentProductHandle || (window.pdp.currentProduct && window.pdp.currentProduct.handle))) ||
      (catalog[0] && catalog[0].handle) ||
      ''
    )
  }

  function money(cents) {
    const n = Number(cents) || 0
    const dollars = n / 100
    const formatted = dollars.toFixed(2).replace(/\.00$/, '')
    return '$' + formatted
  }

  function isSoldOut(v) {
    return !v.available || v.qty === 0
  }

  function colorSub(v) {
    const desc = DESC[v.title] || ''
    if (v.qty > 0 && v.qty < 5) return 'Only ' + v.qty + ' left' + (desc ? ' · ' + desc : '')
    return desc
  }

  function unitPrice(item) {
    if (!item) return 1000
    if (item.price != null) return Number(item.price)
    const v = item.variants && item.variants[0]
    return v && v.price != null ? Number(v.price) : 1000
  }

  function paintBasket(item) {
    if (gated) {
      applyGate()
      return
    }
    const n = Object.keys(qty).reduce((sum, id) => sum + (qty[id] || 0), 0)
    const atc = visibleAtcButton()
    if (atc) {
      atc.classList.remove('blocked')
      atc.disabled = false
      atc.classList.toggle('empty', n === 0)
      const label = atc.querySelector('[data-ss-atc-label]')
      if (label) label.textContent = n === 0 ? 'Choose a color ↓' : 'ADD TO CART'
      const amt = atc.querySelector('[data-ss-atc-amt]')
      if (amt) amt.textContent = n ? money(n * unitPrice(item)) : ''
    }
    root.querySelectorAll('[data-ss-atc-hint]').forEach((hint) => {
      hint.textContent = 'One set = left and right shield · $10 each'
    })
  }

  // Gate: colors and the CTA stop being usable, and the CTA says why rather than
  // going gray — a gray button reads as sold out, not as wrong item.
  function applyGate() {
    const sel = root.querySelector('[data-ss-fits]')
    if (sel) sel.classList.toggle('warn', gated)
    const warn = root.querySelector('[data-ss-fit-warn]')
    if (warn) warn.hidden = !gated
    const help = root.querySelector('[data-ss-fit-help]')
    if (help) help.hidden = gated
    const cols = root.querySelector('[data-ss-cols]')
    if (cols) {
      cols.classList.toggle('locked', gated)
      const colSel = cols.closest('.nvz-sel')
      if (colSel) colSel.classList.toggle('locked', gated)
    }
    const note = root.querySelector('[data-ss-fits-note]')
    if (note) note.textContent = gated ? '' : currentHandle()
    if (!gated) return
    const atc = visibleAtcButton()
    if (atc) {
      atc.classList.remove('empty')
      atc.classList.add('blocked')
      atc.disabled = true
      const label = atc.querySelector('[data-ss-atc-label]')
      if (label) label.textContent = 'Not compatible with a regular pair'
      const amt = atc.querySelector('[data-ss-atc-amt]')
      if (amt) amt.textContent = ''
    }
    root.querySelectorAll('[data-ss-atc-hint]').forEach((hint) => {
      hint.textContent = 'Z87+ frames only · shields are final sale'
    })
  }

  function setGated(next) {
    gated = next
    Object.keys(qty).forEach((k) => delete qty[k])
    const item = catalogItem(currentHandle())
    renderColors(item)
    applyGate()
    paintBasket(item)
  }

  function visibleAtcBlock() {
    const blocks = root.querySelectorAll('.product__information .product__information_block.atc')
    for (let i = 0; i < blocks.length; i++) {
      const el = blocks[i]
      if (el.hidden || el.classList.contains('hidden')) continue
      if (el.offsetParent === null && getComputedStyle(el).display === 'none') continue
      return el
    }
    return root.querySelector('.product__information .product__information_block.atc')
  }

  function visibleAtcButton() {
    const block = visibleAtcBlock()
    return block ? block.querySelector('[data-ss-atc]') : root.querySelector('[data-ss-atc]')
  }

  // Every .atc block gets the shield button: the theme injects a fresh standard
  // ATC per handle on swap, and CSS hides .atc-button, so a missed block = no button.
  function ensureAtcMarkup(productId) {
    const blocks = root.querySelectorAll('.product__information .product__information_block.atc')
    const block =
      root.querySelector('.product__information .nvz-atc-block') || visibleAtcBlock()
    if (!block) return
    blocks.forEach((el) => {
      if (el !== block) el.hidden = true
    })
    if (productId) block.setAttribute('product_id', String(productId))
    block.classList.remove('hidden')
    block.hidden = false
    if (!block.querySelector('[data-ss-atc]')) {
      const old = block.querySelector('.atc-button')
      const btn =
        '<button type="button" class="nvz-atc empty" data-ss-atc><span data-ss-atc-label>Choose a color ↓</span><span class="nvz-atcamt" data-ss-atc-amt></span></button>'
      if (old) old.outerHTML = btn
      else block.insertAdjacentHTML('afterbegin', btn)
    }
    const wrap = block.closest('.nvz-atc-wrap')
    const hintHost = wrap || block.parentElement
    if (hintHost && !hintHost.querySelector('[data-ss-atc-hint]')) {
      const target = wrap || block
      target.insertAdjacentHTML(
        wrap ? 'beforeend' : 'afterend',
        '<p class="nvz-atchint" data-ss-atc-hint>One set = left and right shield · $10 each</p>'
      )
    }
    block.classList.add('nvz-atc-block')
  }

  function renderColors(item) {
    const box = root.querySelector('[data-ss-cols]')
    if (!box || !item) return
    box.innerHTML = ''
    ;(item.variants || []).forEach((v) => {
      const q = qty[v.id] || 0
      const out = isSoldOut(v)
      const state = notify[v.id]
      const row = document.createElement('div')
      row.className =
        'nvz-crow' + (out ? ' out' : '') + (q > 0 ? ' picked' : '') + (state === 'done' ? ' wait' : '')
      row.setAttribute('data-ss-color', String(v.id))

      const sw = document.createElement('span')
      sw.className = 'nvz-csw'
      sw.style.backgroundColor = SW[v.title] || '#9aa0a6'
      row.appendChild(sw)

      const tx = document.createElement('span')
      tx.className = 'nvz-ctx'
      const nm = document.createElement('b')
      nm.textContent = v.title
      const sub = document.createElement('span')
      // Sold out takes the blame and answers the only question that follows it —
      // is it coming back.
      if (out && state === 'done') sub.textContent = "You're on the list — we'll email you first"
      else if (out) sub.innerHTML = 'Sold out &mdash; we suck. <b>More On The Way.</b>'
      else sub.textContent = colorSub(v)
      tx.appendChild(nm)
      tx.appendChild(sub)
      row.appendChild(tx)

      if (out) {
        if (state === 'done') {
          const ok = document.createElement('span')
          ok.className = 'nvz-cdone'
          ok.textContent = 'On the list ✓'
          row.appendChild(ok)
        } else {
          const nb = document.createElement('button')
          nb.type = 'button'
          nb.className = 'nvz-cnote'
          nb.textContent = 'Notify me'
          nb.addEventListener('click', function () {
            notify[v.id] = 'open'
            renderColors(item)
            focusMail(v.id)
          })
          row.appendChild(nb)
        }
      } else {
        if (q > 0) {
          const st = document.createElement('span')
          st.className = 'nvz-cstep'
          const mi = document.createElement('button')
          mi.type = 'button'
          mi.textContent = '−'
          mi.setAttribute('aria-label', 'Remove one ' + v.title)
          mi.addEventListener('click', function () {
            setQty(item, v, q - 1)
          })
          const n = document.createElement('i')
          n.textContent = q
          const pl = document.createElement('button')
          pl.type = 'button'
          pl.textContent = '+'
          pl.setAttribute('aria-label', 'Add one ' + v.title)
          pl.addEventListener('click', function () {
            setQty(item, v, q + 1)
          })
          st.appendChild(mi)
          st.appendChild(n)
          st.appendChild(pl)
          row.appendChild(st)
        } else {
          const add = document.createElement('button')
          add.type = 'button'
          add.className = 'nvz-cadd'
          add.textContent = 'Add'
          add.addEventListener('click', function () {
            setQty(item, v, 1)
          })
          row.appendChild(add)
        }
      }
      if (!out) {
        box.appendChild(row)
        return
      }

      const wrap = document.createElement('div')
      wrap.className = 'nvz-cwrap out'
      wrap.appendChild(row)
      if (state === 'open' || state === 'sending') wrap.appendChild(mailForm(item, v))
      box.appendChild(wrap)
    })
  }

  // Inline capture — one field inside the row's own card, so nothing navigates
  // away and the shopper never loses the colour they were looking at.
  function mailForm(item, v) {
    const f = document.createElement('div')
    f.className = 'nvz-cmail'
    const inp = document.createElement('input')
    inp.type = 'email'
    inp.placeholder = 'you@email.com'
    inp.id = 'ss-mail-' + v.id
    inp.setAttribute('aria-label', 'Email me when ' + v.title + ' is back')
    const known = window._BISConfig && window._BISConfig.customer && window._BISConfig.customer.email
    inp.value = mailDraft[v.id] || known || ''
    if (notifyErr[v.id]) inp.classList.add('err')
    const go = document.createElement('button')
    go.type = 'button'
    go.textContent = notify[v.id] === 'sending' ? 'Signing up…' : 'Sign me up'
    go.disabled = notify[v.id] === 'sending'
    const submit = function () {
      if (notify[v.id] === 'sending') return
      const email = inp.value.trim()
      mailDraft[v.id] = email
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        inp.classList.add('err')
        inp.focus()
        return
      }
      subscribeBackInStock(item, v, email)
    }
    go.addEventListener('click', submit)
    inp.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') submit()
    })
    inp.addEventListener('input', function () {
      inp.classList.remove('err')
      delete notifyErr[v.id]
      const msg = f.parentNode && f.parentNode.querySelector('.nvz-cmail__err')
      if (msg) msg.remove()
    })
    f.appendChild(inp)
    f.appendChild(go)
    if (!notifyErr[v.id]) return f
    const frag = document.createDocumentFragment()
    const msg = document.createElement('p')
    msg.className = 'nvz-cmail__err'
    msg.textContent = notifyErr[v.id]
    frag.appendChild(f)
    frag.appendChild(msg)
    return frag
  }

  // Same Back in Stock app the Z87 and Rx PDPs post to.
  function subscribeBackInStock(item, v, email) {
    const fail = function (message) {
      notify[v.id] = 'open'
      notifyErr[v.id] = message || 'Something went wrong — try again.'
      renderColors(item)
      focusMail(v.id)
    }
    if (typeof window.BIS === 'undefined' || typeof window.BIS.create !== 'function') {
      fail()
      return
    }
    notify[v.id] = 'sending'
    delete notifyErr[v.id]
    renderColors(item)
    window.BIS.create(email, v.id, item.id, { accepts_marketing: false })
      .then(function (resp) {
        if (resp && resp.status === 'OK') {
          notify[v.id] = 'done'
          renderColors(item)
          return
        }
        const errs = resp && resp.errors ? Object.keys(resp.errors).map((k) => resp.errors[k]) : []
        fail(errs.join(' '))
      })
      .catch(function () {
        fail()
      })
  }

  function focusMail(id) {
    const el = root.querySelector('#ss-mail-' + id)
    if (el) el.focus()
  }

  function setQty(item, variant, next) {
    const cap = variant.qty > 0 ? variant.qty : variant.available ? 99 : 0
    const v = Math.max(0, Math.min(cap, next))
    if (v === 0) delete qty[variant.id]
    else qty[variant.id] = v
    renderColors(item)
    paintBasket(item)
  }

  function applyShopAndFit(item) {
    if (!item) return
    const titleEl = root.querySelector('[data-ss-shop-title]')
    const subEl = root.querySelector('[data-ss-shop-sub]')
    const row = root.querySelector('[data-ss-shop-row]')
    const name = String((item && (item.shopName || item.label)) || '')
      .replace(/\s*Z87\+?\s*$/i, '')
      .trim()
    if (titleEl) titleEl.textContent = name ? 'Shop ' + name : 'Shop Z87+ frames'
    if (subEl) subEl.textContent = 'A set is already in the box'
    if (row) row.setAttribute('href', (item && item.shopUrl) || '/collections/safety-eyewear-z87')
    const fit = root.querySelector('[data-ss-fit-copy]')
    if (fit && item.fitCopy) fit.textContent = item.fitCopy
    const note = root.querySelector('[data-ss-fits-note]')
    if (note) note.textContent = gated ? '' : item.handle || ''
    const lab = root.querySelector('[data-ss-cols]') && root.querySelector('.nvz-sel--group .nvz-sel__v')
    if (lab && item.price != null) lab.textContent = money(item.price) + ' each'
  }

  function resetColorStaging() {
    Object.keys(qty).forEach((k) => delete qty[k])
    const item = catalogItem(currentHandle())
    renderColors(item)
    paintBasket(item)
  }

  function applyCatalog(handle) {
    lastHandle = handle || lastHandle
    const sel = root.querySelector('[data-ss-fits]')
    if (sel && handle && !gated && sel.value !== handle) sel.value = handle
    resetColorStaging()
    applyShopAndFit(catalogItem(handle))
  }

  function switchFit(handle) {
    if (!handle) return
    if (handle === GATE_VALUE) {
      setGated(true)
      return
    }
    if (gated) setGated(false)
    const from =
      lastHandle ||
      (window.pdp &&
        (window.pdp.currentProductHandle ||
          (window.pdp.currentProduct && window.pdp.currentProduct.handle))) ||
      ''
    if (handle === from) return
    applyCatalog(handle)
    if (typeof window.switchPdpSizeProduct === 'function') {
      window.switchPdpSizeProduct(handle, { kind: 'frame', allowFallbackNav: false })
    }
  }

  function paintCart(res) {
    if (!res || !res.sections) return
    if (res.sections['cart-drawer'] && window.jQuery) {
      window.jQuery('#shopify-section-cart-drawer .section_holder').html(
        window.jQuery(res.sections['cart-drawer']).find('.section_holder').html()
      )
    }
    if (res.sections['header-classic']) {
      const bubbleEl = new DOMParser()
        .parseFromString(res.sections['header-classic'], 'text/html')
        .querySelector('.header-cart__count')
      if (!bubbleEl) return
      const bubble = bubbleEl.innerHTML
      document.querySelectorAll('.header-cart__count').forEach((element) => {
        element.innerHTML = bubble
        if (+bubbleEl.textContent > 0) {
          if (window.jQuery) window.jQuery(element).show()
          else element.style.display = ''
        } else if (window.jQuery) {
          window.jQuery(element).hide()
        } else {
          element.style.display = 'none'
        }
      })
    }
    if (typeof window.open_slider_cart === 'function') window.open_slider_cart()
  }

  function addSelectedColors(btn) {
    const items = Object.keys(qty)
      .filter((id) => qty[id] > 0)
      .map((id) => ({ id: Number(id) || id, quantity: qty[id] }))
    if (!items.length) return
    btn.disabled = true
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify({
        items: items,
        sections: ['cart-drawer', 'header-classic']
      })
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.status && res.status >= 400) throw res
        paintCart(res)
        btn.disabled = false
        resetColorStaging()
      })
      .catch(() => {
        btn.disabled = false
        paintBasket(catalogItem(currentHandle()))
      })
  }

  function flashColors() {
    const cols = root.querySelector('[data-ss-cols]')
    if (!cols) return
    cols.scrollIntoView({ behavior: 'smooth', block: 'center' })
    cols.classList.remove('flash')
    void cols.offsetWidth
    cols.classList.add('flash')
    setTimeout(function () {
      cols.classList.remove('flash')
    }, 800)
  }

  function openFitModal() {
    const modal = root.querySelector('[data-ss-fit-modal]')
    if (!modal) return
    modal.hidden = false
    modal.classList.add('is-open')
    document.body.classList.add('ss-fit-open')
  }

  function closeFitModal() {
    root.querySelectorAll('[data-ss-fit-modal]').forEach((modal) => {
      modal.classList.remove('is-open')
      modal.hidden = true
    })
    document.body.classList.remove('ss-fit-open')
  }

  root.addEventListener(
    'click',
    function (event) {
      if (event.target.closest('.wk-button') || event.target.closest('[class*="wishlist"]')) return

      const atcBtn = event.target.closest('[data-ss-atc]')
      const atcBlock = event.target.closest('.product__information_block.atc')
      if (atcBtn || (atcBlock && !event.target.closest('[data-ss-atc-hint]'))) {
        event.preventDefault()
        event.stopImmediatePropagation()
        if (gated) return
        const n = Object.keys(qty).reduce((sum, id) => sum + (qty[id] || 0), 0)
        if (n === 0) flashColors()
        else addSelectedColors(atcBtn || visibleAtcButton())
      }
    },
    true
  )

  const fits = root.querySelector('[data-ss-fits]')
  if (fits) {
    fits.addEventListener('change', function (event) {
      switchFit(event.target.value)
    })
  }

  root.addEventListener('click', function (event) {
    if (event.target.closest('[data-ss-open-fit]')) {
      event.preventDefault()
      openFitModal()
      return
    }
    if (event.target.closest('[data-ss-fit-close]')) {
      event.preventDefault()
      closeFitModal()
    }
  })

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeFitModal()
  })

  document.addEventListener('state:change:currentProduct', function (event) {
    const product = event.detail && event.detail.value
    if (!product || !document.contains(root)) return
    ensureAtcMarkup(product.id)
    if (product.handle && product.handle !== lastHandle) applyCatalog(product.handle)
    else paintBasket(catalogItem(currentHandle()))
  })

  applyCatalog(currentHandle())
  // Browsers restore select state on back/forward — keep the gate in step with it.
  if (fits && fits.value === GATE_VALUE) setGated(true)

  if (window.sepStorefront && typeof window.sepStorefront.productByHandle === 'function') {
    catalog.forEach(function (p) {
      if (p && p.handle) window.sepStorefront.productByHandle(p.handle).catch(function () {})
    })
  }
})()
